import { createContext } from "react";

const Context = createContext({
  addChild: () => null,
  engine: null,
  isModalSidebar: false,
  setIsModalSidebar: () => null,
  saveProject: () => null,
  contactFields: [],
  reportingTopics: [],
  reportingTemplates: [],
  apiProfiles: [],
});
export default Context;
